import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute, Params }     from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'calculate-analyzer',
  templateUrl: './calculate-analyzer.component.html',
  styleUrls: ['./calculate-analyzer.component.scss']
})
export class CalculateAnalyzer implements OnInit {
  
  orderId: number;
  accessToken: string;
  client: string;
  uid: string;
  url: string

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public sanitizer: DomSanitizer
    ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.orderId = params['order_id'];
      this.accessToken = localStorage.getItem('token')
      this.client = localStorage.getItem('client')
      this.uid = localStorage.getItem('uid')
      if(environment.apiBaseUrl == 'https://apisystem.truventor.com/'){
        this.url = environment.cadViewerBase + "tool/calculate?order_id="+this.orderId+"&access_token="+this.accessToken+"&client="+this.client+"&uid="+this.uid+"&env=prod"
      }
      else{
        this.url = environment.cadViewerBase + "tool/calculate?order_id="+this.orderId+"&access_token="+this.accessToken+"&client="+this.client+"&uid="+this.uid      
      }
     
    });
  }

//   isCustomer(){
//     return this.userType == "customer"
//   }

}